import styled from 'styled-components';
import { withTheme } from '../../ThemeProvider';
import { responsiveStyles } from '../../../core/utils/responsiveStyles'; // TODO Sudhir: Add documentation and test cases.

var HintText = withTheme(styled.div.withConfig({
  displayName: "HintText",
  componentId: "sc-j7otxh-0"
})(function (_ref) {
  var _responsiveStyles$fon, _responsiveStyles, _coreTheme$hintText, _coreTheme$hintText$f, _coreTheme$hintText2;

  var coreTheme = _ref.coreTheme,
      error = _ref.error;
  return {
    color: error ? coreTheme.cl_pri_d3 : coreTheme.cl_ter_base,
    fontSize: (_responsiveStyles$fon = (_responsiveStyles = responsiveStyles({
      fontSize: (_coreTheme$hintText = coreTheme.hintText) === null || _coreTheme$hintText === void 0 ? void 0 : _coreTheme$hintText.fontSize
    }, coreTheme)) === null || _responsiveStyles === void 0 ? void 0 : _responsiveStyles.fontSize) !== null && _responsiveStyles$fon !== void 0 ? _responsiveStyles$fon : coreTheme.fs_md,
    fontFamily: (_coreTheme$hintText$f = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$hintText2 = coreTheme.hintText) === null || _coreTheme$hintText2 === void 0 ? void 0 : _coreTheme$hintText2.fontFamily) !== null && _coreTheme$hintText$f !== void 0 ? _coreTheme$hintText$f : coreTheme.ff_sec_thin,
    flex: "0 0 85%"
  };
}));
export default HintText;